import { useLazySearchProductsQuery } from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { useCallback, useState } from 'react'
import { useAccountBranchIdsParams } from '@/core/hooks/useAccountBranchIdsParams.ts'
import { Product } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { useSelector } from 'react-redux'
import { selectPlanProducts } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { mapProductOrderableToProduct } from '@/data/replenishmentPlan/mappers/mapProductOrderableToProduct.ts'

const useSearchProductsToReplace = () => {
  const [loading, setLoading] = useState(false)
  const [products, setProducts] = useState<Product[]>([])

  const planProducts = useSelector(selectPlanProducts)

  const { branchId } = useAccountBranchIdsParams()

  const [searchProductsQuery] = useLazySearchProductsQuery()

  const searchProducts = useCallback(
    async (term: string, categoryCode?: string) => {
      setLoading(true)

      try {
        const data = await searchProductsQuery({
          branchId,
          term,
          categoryCode,
        }).unwrap()

        if (!data) {
          return
        }

        const products = (
          data.productsOrderable?.map((product) => {
            return mapProductOrderableToProduct(product!)
          }) ?? []
        )
          .filter(
            (product) =>
              !planProducts.some(
                (planProduct) => planProduct.id === product.id,
              ),
          )
          .sort((a, b) => a.price - b.price)

        setProducts(products)
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    },
    [branchId, planProducts, searchProductsQuery],
  )

  return { searchProducts, products, setProducts, isLoading: loading }
}

export { useSearchProductsToReplace }
